import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Subscriber } from '../../entities/Subscriber';
import { toast } from '../ui/use-toast';

export default function NewsletterSignup({ compact = false, onSuccess }) {
    const { t, i18n } = useTranslation();
    const [email, setEmail] = React.useState('');
    const [name, setName] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim() || !email.trim()) {
            toast({
                variant: "destructive",
                title: t('toast.error_title'),
                description: t('toast.fill_all_fields_desc'),
            });
            return;
        }

        setIsLoading(true);

        try {
            // שולחים את השפה הנוכחית יחד עם שאר הפרטים
            await Subscriber.create({ email, name, language: i18n.language });

            toast({
                title: t('toast.subscription_success_title'),
                description: t('toast.subscription_success_desc'),
            });

            if (onSuccess) {
                onSuccess();
            }

            setEmail('');
            setName('');
        } catch (error) {
            console.error('Error:', error);
            const errorMsg = error.response?.data?.msg === 'Email already subscribed'
                ? t('toast.email_exists_desc')
                : t('toast.generic_error_desc');

            toast({
                variant: "destructive",
                title: t('toast.error_title'),
                description: errorMsg
            });
        }
        setIsLoading(false);
    };

    const formContent = (
        <form onSubmit={handleSubmit} className="space-y-3" autoComplete="off">
            <Input
                type="text"
                placeholder={t('forms.name_placeholder')}
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className={compact
                    ? "bg-white border-gray-300 text-[#232946] placeholder:text-gray-500"
                    : "bg-white/10 border-white/20 text-white placeholder:text-[#b8c1ec]"}
            />
            <Input
                type="email"
                placeholder={t('forms.email_placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className={compact
                    ? "bg-white border-gray-300 text-[#232946] placeholder:text-gray-500"
                    : "bg-white/10 border-white/20 text-white placeholder:text-[#b8c1ec]"}
            />
            <Button
                type="submit"
                disabled={isLoading}
                className="w-full bg-[#eebbc3] hover:bg-[#e5a9b3] text-[#232946]"
            >
                {isLoading ? t('newsletter_form.submitting_button') : t('newsletter_form.submit_button')}
            </Button>
        </form>
    );

    if (compact) {
        return formContent;
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-[#232946] text-white rounded-xl p-6"
            id="newsletter-form"
        >
            <h3 className="text-lg font-semibold mb-3">
                {t('newsletter_form.title')}
            </h3>
            <p className="text-[#b8c1ec] text-sm mb-4">
                {t('newsletter_form.description')}
            </p>
            {formContent}
        </motion.div>
    );
}